/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestorBankAccountSortField {
    OWNER_NAME = 'ownerName',
    VERIFICATION_STATUS = 'verificationStatus',
    UPDATED_AT = 'updatedAt',
    CREATED_AT = 'createdAt',
}
